var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        title: "扫码查询",
        width: "90%",
        "before-close": _vm.closeDialog,
        "custom-class": "scan-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-row",
        { attrs: { justify: "space-between" } },
        [
          _c("el-col", { attrs: { span: 12 } }, [
            _c("div", [
              _vm._v(
                "请将扫码枪连接至电脑, 并保证当前弹窗处理激活状态，当前已扫 "
              ),
              _c("span", { staticStyle: { color: "#1db0fc" } }, [
                _vm._v(_vm._s(_vm.codes.length)),
              ]),
              _vm._v(" 条"),
            ]),
          ]),
          _c(
            "el-col",
            { staticStyle: { "text-align": "right" }, attrs: { span: 12 } },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.codes.length,
                      expression: "codes.length",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.exportFile },
                },
                [_vm._v("导出表格")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "tableRef",
          staticStyle: { width: "100%", "margin-top": "24px" },
          attrs: { data: _vm.scanList, height: "65vh" },
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "90" },
          }),
          _vm._l(_vm.headers, function (item, i) {
            return _c("el-table-column", {
              key: "header_" + i,
              attrs: {
                prop: item.prop,
                label: item.label,
                align: item.align,
                width: item.width,
              },
            })
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }